export default {
  profile: 'profile',
  notifcations: 'notifications',
  liqpay: 'liqpay',
  fiscalization: 'fiscalization'
}
